import redditLogo from './reddit.png';
import facebookLogo from './facebook.png';
import xLogo from './x.png';

const socialLogos = {
    reddit: redditLogo,
    facebook: facebookLogo,
    x: xLogo
};

export default socialLogos;
